import { atom } from "recoil";

export const activeConnectorState = atom({
  key: "activeConnectorState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
